import { useAuth } from '../../public/site/AuthProvider.js';
import { useDialog } from '../../public/site/DialogProvider.js';
import { MigrationLogin } from '../Login/MigrationLogin.js';
import { ElisaIdLogin } from './ElisaIdLogin.js';
import { NOEOldLogin } from './NOEOldLogin.js';

export const SelfServiceLogin = () => {
  const { elisaIdV3Enabled, inMigrationPhase } = useAuth();
  const dialog = useDialog();

  if (inMigrationPhase) {
    return <MigrationLogin dialog={dialog} />;
  }

  if (elisaIdV3Enabled) {
    return <ElisaIdLogin />;
  }

  return <NOEOldLogin />;
};
